import { useCallback, useEffect, useState, useRef } from 'react';
import { useLocation, history, useDispatch } from 'umi';
import qs from 'qs';
import { Box } from '@material-ui/core';
import SearchGroup from './components/search_group/SearchGroup';
import ResultList from './components/result_list/ResultList';

export default () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [tabValue, setTabValue] = React.useState(0);
  const { query, pathname } = location;
  const searchRef = useRef();
  const [isSearch, setIsSearch] = useState(false);
  // 结构到所有查询条件，包括分页条件
  const {
    orderNo = '',
    orderType = '',
    channel = '',
    memberCode = '',
    mobile = '',
    pageNum = '1',
    pageSize,
    store,
    startDate = null,
    endDate = null,
    initTabValue = 0,
    searchStatus = 0,
  } = query;
  React.useEffect(() => {
    setTabValue(Number(initTabValue));
  }, [initTabValue]);
  // 查询事件处理
  const handleSearch = (newParam) => {
    setIsSearch(true);
    console.log('💢felix => handleSearch => newParam', newParam);
    history.replace(
      `${pathname}?${qs.stringify({
        ...newParam,
        startDate: newParam.date?.startDate,
        endDate: newParam.date?.endDate,
        initTabValue: tabValue,
        pageNum: '1',
        pageSize,
        searchStatus: searchStatus + 1,
      })}`,
    );
  };

  // 翻页事件处理
  const handlePageChange = (p) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        pageNum: p.pageNum,
        pageSize: p.pageSize,
      })}`,
    );
  };

  // 重置事件处理
  const handleRestClick = (rs) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...rs,
        pageSize: '10',
        pageNum: '1',
      })}`,
    );
  };
  //获取优惠券列表
  const fetchCouponList = useCallback(() => {
    const values = {
      pageNum: Number(pageNum),
      pageSize,
      orderNo: orderNo ? orderNo : null,
      orderType: orderType ? orderType : null,
      channel: channel ? channel : null,
      memberCode: memberCode ? memberCode : null,
      mobile: mobile ? mobile : null,
      // store: store ? store : null,
      stores: store ? store.split('-') : null,
      tradeTimeStart: startDate,
      tradeTimeEnd: endDate,
    };
    if (isSearch) {
      window.NE_DAWN.trigger(searchRef.current, {
        event: '_ec', // 事件名
        params: { ...values }, // 事件公参
      });
    }
    setIsSearch(false);
    dispatch({
      type: 'orderList/getOrderList',
      payload: {
        values: { ...values, searchCount: false },
      },
    });
    dispatch({
      type: 'orderList/getOrderSummary',
      payload: {
        values,
      },
    });
  }, [
    dispatch,
    pageNum,
    pageSize,
    orderNo,
    orderType,
    channel,
    memberCode,
    mobile,
    startDate,
    endDate,
    store,
    searchStatus,
  ]);

  useEffect(() => {
    fetchCouponList();
  }, [fetchCouponList]);

  return (
    <Box
      data-log={JSON.stringify({
        oid: 'page_offline_store_order_management_list',
        isPage: true,
        params: {
          initUrl: window.location.origin + window.location.pathname,
        },
        events: ['_pv', '_pd'],
      })}
    >
      <SearchGroup
        searchRef={searchRef}
        query={query}
        handleSearch={(par) => handleSearch(par)}
        restClick={handleRestClick}
        tabValue={tabValue}
        setTabValue={setTabValue}
      />
      <ResultList
        // history={props.history}
        handlePageChange={handlePageChange}
        pageData={{ pageNum, pageSize }}
      />
    </Box>
  );
};
